// extracted by mini-css-extract-plugin
module.exports = {"container":"_3vxkhH","title":"_2cbPBa"};